import React, { Component } from "react";
import ReactPaginate from "react-paginate";
import DropdownComp from "../../components/commonDropdown";
import { Row, Col, ProgressBar, Image, Button } from "react-bootstrap";

class TutorReview extends Component {
  constructor() {
    super();
    this.state = {
      page: 1,
      paginationpages: 1,
      reviewArr: [
        {
          userName: "James Smith",
          subject: "Maths (GCSE)",
          address: "L15 2HY",
          date: "9 Dec 2020",
          message:
            "After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with.After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with",
        },
        {
          userName: "Sam J.",
          subject: "Maths (GCSE)",
          address: "L15 2HY",
          date: "9 Dec 2020",
          message:
            "After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with.After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with",
        },
        {
          userName: "Fred K",
          subject: "Maths (GCSE)",
          address: "L15 2HY",
          date: "9 Dec 2020",
          message:
            "After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with.After taking both GCSE maths and geography with sessions with Cristopher with flying color,he taught me a lot from basic aljebra to complex simmulti to complex simmulti sessions with",
        },
      ],
    };
  }
  nameFirstChar = (name) => {
    return (name = name.charAt(0));
  };

  handlePageClick = (data) => {
    // let { tutorList, paginateTutor } = this.state;
    // let selected = data.selected + 1;
    // let start = selected * 5 - 4;
    // let end = selected * 5;
    // paginateTutor = tutorList.filter((value, i) => start <= i && end >= i);
    // this.setState({ page: selected, paginateTutor });
  };
  render() {
    const { reviewArr, paginationpages } = this.state;

    let interest = [
      "Communicating",
      "Knowlegde",
      "Teaching style",
      "subject content",
    ];

    let improve = ["Timeline", "Interaction"];
    return (
      <Row style={{marginTop:"60px"}}>
        <Col lg={4} md={4} sm={12} xs={12}>
          <div className="rating-header">
            <h2 className="flex-start-center">
              4.48{" "}
              <Image
                src={require("./../../assets/icons/fillStar.png")}
                style={{
                  width: "22px",
                  marginLeft: "10px",
                  marginBottom: "3px",
                }}
              />
            </h2>
            <p>Overall rating</p>
          </div>
          <hr />
          <div style={{ marginBottom: "30px" }} />
          {[5, 4, 3, 2, 1].map((rating) => (
            <div className="flex-center">
              <div
                style={{ flex: 1, fontSize: "23px" }}
                className="flex-center"
              >
                5
                <Image
                  src={require("./../../assets/icons/star-black.png")}
                  style={{
                    width: "22px",
                    marginLeft: "10px",
                    marginBottom: "3px",
                  }}
                />
              </div>
              <div className="progress-div">
                <ProgressBar now={(rating / 5) * 100} />
              </div>
            </div>
          ))}
          <div style={{ marginBottom: "30px" }} />
          <hr />
          <div style={{ marginBottom: "30px" }} />

          <div className="tutor-about-div">
            <h3>What student like</h3>
            {interest.map((inte, i) => (
              <div className="flex-center tutor-about-panel">
                <span className="flex-center">{i}</span>
                <span>{inte}</span>
              </div>
            ))}
          </div>
          <div style={{ marginBottom: "30px" }} />
          <hr />
          <div style={{ marginBottom: "30px" }} />

          <div className="tutor-about-div">
            <h3>What needs improvement</h3>
            {improve.map((imp, i) => (
              <div className="flex-center tutor-about-panel">
                <span className="flex-center">{i}</span>
                <span>{imp}</span>
              </div>
            ))}
          </div>
        </Col>
        <Col lg={8} md={8} sm={12} xs={12}>
          <div className="flex-between-center">
            <div className="rating-header">
              <h2 className="flex-start-center">300</h2>
              <p>Total reviews</p>
            </div>
            <div style={{ width: "163px" }}>
              <DropdownComp />
            </div>
          </div>
          <div className="review-div">
            {reviewArr.length
              ? reviewArr.map((review) => (
                  <div className="review-iteration">
                    <div className="flex-between-center">
                      <div className="flex-center">
                        {review?.userName ? (
                          <h3 className="circle">
                            {this.nameFirstChar(review?.userName)}
                          </h3>
                        ) : (
                          <h3 className="circle">?</h3>
                        )}
                        <span className="flex-col">
                          <span className="username">{review?.userName}</span>
                          <span>
                            <span>{review?.subject} </span>
                            <span>{review?.address}</span>{" "}
                            <span>{review?.date}</span>
                          </span>
                        </span>
                      </div>
                      <div
                        className="flex-col-center"
                        style={{ alignItems: "flex-end" }}
                      >
                        <div className="username">Overall rating</div>
                        <div
                          className="flex-between-center"
                          style={{ width: "110px" }}
                        >
                          {[1, 2, 3, 4, 5].map((star) => (
                            <Image
                              src={require("./../../assets/icons/star-black.png")}
                              style={{ width: "15px" }}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="truncate" style={{ height: "50px" }}>
                      <p>{review?.message}</p>
                    </div>
                    <div
                      className="blue-txt flex-end-center"
                      style={{ fontWeight: "500", fontSize: "17px" }}
                    >
                      Read review
                    </div>
                    <hr />
                    <div className="blue-txt" style={{ fontSize: "16px" }}>
                      <span style={{ fontWeight: "500" }}>Endorsement : </span>
                      <span>
                        Knowlegdeable,Excellent communicator, Punctual
                      </span>
                    </div>
                  </div>
                ))
              : "no data"}
          </div>
        </Col>
        <Col
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="flex-center-center pagnination-Col"
        >
          <ReactPaginate
            previousLabel={
              <span>
                <Image
                  style={{ transform: "rotate(180deg)", width: "18px" }}
                  src={require("./../../assets/icons/directional.png")}
                />
              </span>
            }
            nextLabel={
              <span>
                <Image
                  style={{ transform: "rotate(0deg)", width: "18px" }}
                  src={require("./../../assets/icons/directional.png")}
                />
              </span>
            }
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={paginationpages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={1}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </Col>
      </Row>
    );
  }
}

export default TutorReview;
